import React from "react";
import { useMediaQuery } from "react-responsive";
const logos = [
  "blissclub.png",
  "boat.png",
  "boult.png",
  "bsc.png",
  "dotkey.png",
  "dr_sheth.png",
  "fablestreet.png",
  "foxtale.png",
  "freakins.png",
  "frido.png",
  "hautesauce.png",
  "hypen.png",
  "innovist.png",
  "juicy.png",
  "levis.png",
  "libas.png",
  "macffine.png",
  "neeman.png",
  "noise.png",
  "palm.png",
  "plamano.png",
  "uptown.png",
  "west.png",
];

const SectionThree = () => {
  const logoPairs = [];
  for (let i = 0; i < logos.length; i += 2) {
    logoPairs.push([logos[i], logos[i + 1]]);
  }

  const isMobile = useMediaQuery({ maxWidth: 768 });

  // Split logos into 2 halves for 2 rows
  const half = Math.ceil(logos.length / 2);
  const row1 = logos.slice(0, half);
  const row2 = logos.slice(half);


  return (
    <div className="section-three-checkout">
      <div className="container-fluid">
        <div className="sec-three-container">
          {/* LEFT SECTION */}
          <div className="left-sec-three">
            <div className="shopi-div">
              <img src="/assets/images/checkout-v-one/shopify.png" alt="" />
            </div>
            <div className="sec-three-head">
              <h1>"We scaled COD while keeping RTOs in check"</h1>
              {isMobile ? (
                <p>
                  Echoed by 15,000+ brands across India
                </p>
              ) : (
                <p>Echoed by 15,000+ brands across India</p>
              )}
            </div>
          </div>

          {/* RIGHT SECTION (Ticker) */}
          <div className="right-sec-three">
            {isMobile ? (
              <div className="logo-slider-horizontal">
                {/* Row 1 (left → right) */}
                <div className="logo-row-horizontal">
                  {row1.concat(row1).map((logo, idx) => (
                    <div className="logo-item" key={`row1-${idx}`}>
                      <img
                        src={`/assets/images/checkout-v-one/${logo}`}
                        alt="brand logo"
                      />
                    </div>
                  ))}
                </div>
                {/* Row 2 (right → left) */}
                <div className="logo-row-horizontal reverse">
                  {row2.concat(row2).map((logo, idx) => (
                    <div className="logo-item" key={`row2-${idx}`}>
                      <img
                        src={`/assets/images/checkout-v-one/${logo}`}
                        alt="brand logo"
                      />
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <div className="logo-track-vertical">
                {/* duplicate pairs once for seamless loop */}
                {logoPairs.concat(logoPairs).map((pair, idx) => (
                  <div className="logo-row" key={idx}>
                    {pair.map(
                      (logo, i) =>
                        logo && (
                          <div className="logo-item" key={i}>
                            <img
                              src={`/assets/images/checkout-v-one/${logo}`}
                              alt="brand logo"
                            />
                          </div>
                        )
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionThree;
